import React, { useEffect, useState } from 'react';
import { parentApi, adminApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaEnvelope, FaEnvelopeOpen } from 'react-icons/fa';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';

export default function Messages() {
  const { user } = useAuth();
  const [tab,       setTab]       = useState('inbox');
  const [messages,  setMessages]  = useState([]);
  const [teachers,  setTeachers]  = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [modal,     setModal]     = useState(false);
  const [selected,  setSelected]  = useState(null);
  const [form,      setForm]      = useState({ receiver_id: '', subject: '', body: '' });

  const load = () => {
    setLoading(true);
    parentApi.getMessages(tab).then(r => setMessages(r.data.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [tab]); // eslint-disable-line
  useEffect(() => { adminApi.getTeachers().then(r => setTeachers(r.data.data)).catch(() => {}); }, []);

  const markRead = async (msg) => {
    setSelected(msg);
    if (!msg.is_read && tab === 'inbox') {
      await parentApi.markRead(msg.message_id);
      setMessages(ms => ms.map(m => m.message_id === msg.message_id ? { ...m, is_read: 1 } : m));
    }
  };

  const handleSend = async (e) => {
    e.preventDefault();
    try { await parentApi.sendMessage(form); toast.success('Message sent'); setModal(false); setForm({ receiver_id: '', subject: '', body: '' }); if (tab === 'sent') load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div><h2>Messages</h2><p>Communicate with teachers</p></div>
        <button className="sms-btn sms-btn-primary" onClick={() => { setForm({ receiver_id: '', subject: '', body: '' }); setModal(true); }}><FaPlus size={13} /> New Message</button>
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: '#f3f4f6', borderRadius: 10, padding: 4, width: 'fit-content' }}>
        {[['inbox', 'Inbox'], ['sent', 'Sent']].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} className="sms-btn" style={{ background: tab === k ? '#fff' : 'transparent', boxShadow: tab === k ? '0 1px 4px rgba(0,0,0,0.1)' : 'none', color: tab === k ? '#111' : '#6b7280', padding: '7px 18px', borderRadius: 8 }}>{l}</button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 20 }}>
        {/* Message list */}
        <div className="sms-card" style={{ padding: 0, overflow: 'hidden' }}>
          {loading ? <Spinner /> : messages.length === 0
            ? <div style={{ textAlign: 'center', color: '#9ca3af', padding: '60px 20px' }}>No messages</div>
            : messages.map(m => (
              <div key={m.message_id}
                onClick={() => markRead(m)}
                style={{ padding: '14px 18px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', background: selected?.message_id === m.message_id ? '#eff6ff' : !m.is_read && tab === 'inbox' ? '#f8faff' : '#fff', transition: 'background 0.15s' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {!m.is_read && tab === 'inbox' ? <FaEnvelope size={13} color="#0d6efd" /> : <FaEnvelopeOpen size={13} color="#d1d5db" />}
                    <span style={{ fontWeight: !m.is_read && tab === 'inbox' ? 700 : 500, fontSize: '0.88rem' }}>{tab === 'inbox' ? m.sender_name : m.receiver_name}</span>
                  </div>
                  <span style={{ fontSize: '0.72rem', color: '#9ca3af' }}>{new Date(m.sent_at).toLocaleDateString()}</span>
                </div>
                {m.subject && <div style={{ fontWeight: 600, fontSize: '0.85rem', marginBottom: 3 }}>{m.subject}</div>}
                <div style={{ color: '#9ca3af', fontSize: '0.8rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.body}</div>
              </div>
            ))
          }
        </div>

        {/* Message detail */}
        <div className="sms-card">
          {selected ? (
            <div>
              <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: '1px solid #e5e7eb' }}>
                <h5 style={{ fontWeight: 600, marginBottom: 6 }}>{selected.subject || '(No subject)'}</h5>
                <div style={{ display: 'flex', gap: 16, fontSize: '0.8rem', color: '#6b7280' }}>
                  <span><strong>From:</strong> {tab === 'inbox' ? selected.sender_name : 'You'}</span>
                  <span><strong>To:</strong> {tab === 'inbox' ? 'You' : selected.receiver_name}</span>
                  <span>{new Date(selected.sent_at).toLocaleString()}</span>
                </div>
              </div>
              <p style={{ color: '#374151', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>{selected.body}</p>
            </div>
          ) : <div style={{ textAlign: 'center', color: '#9ca3af', padding: '60px 0' }}>Select a message to read it</div>}
        </div>
      </div>

      <Modal show={modal} onClose={() => setModal(false)} title="New Message">
        <form onSubmit={handleSend}>
          <div style={{ marginBottom: 14 }}>
            <label className="sms-label">To (Teacher) <span style={{ color: '#ef4444' }}>*</span></label>
            <select className="sms-input" value={form.receiver_id} onChange={e => setForm({ ...form, receiver_id: e.target.value })} required>
              <option value="">Select teacher</option>
              {teachers.map(t => <option key={t.user_id} value={t.user_id}>{t.first_name} {t.surname}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label className="sms-label">Subject</label>
            <input className="sms-input" value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} placeholder="Optional subject" />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label className="sms-label">Message <span style={{ color: '#ef4444' }}>*</span></label>
            <textarea className="sms-input" rows={5} value={form.body} onChange={e => setForm({ ...form, body: e.target.value })} required style={{ resize: 'vertical' }} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="submit" className="sms-btn sms-btn-primary">Send</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={() => setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
